import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import '../Styles/destination.css';

export default class Thekkady extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'overview'
    };
  }

  render() {
    const attractions = [
      {
        name: "Periyar Wildlife Sanctuary",
        image: "/assets/img/periyar-sanctuary.png",
        description: "One of the most renowned wildlife sanctuaries in India, home to elephants, tigers, leopards, and over 300 species of birds. The sanctuary surrounds the Periyar Lake.",
        highlight: "Tiger Reserve",
        bestTime: "Oct-Feb",
        duration: "3-4 Hours",
        tip: "Take a boat safari for the best wildlife viewing"
      },
      {
        name: "Periyar Lake",
        image: "/assets/img/periyar-lake.jpg",
        description: "A scenic artificial lake offering boat cruises with excellent opportunities to spot wildlife along the banks. The lake is surrounded by dense forest.",
        highlight: "Boat Safari Spot",
        bestTime: "Morning",
        duration: "1.5-2 Hours",
        tip: "Book boat tickets in advance during peak season"
      },
      {
        name: "Spice Plantations",
        image: "/assets/img/spice-plantation.jpeg",
        description: "Explore vast plantations of cardamom, pepper, cinnamon, nutmeg, and other spices. Guided tours offer insights into spice cultivation and processing.",
        highlight: "Spice Capital",
        bestTime: "All Year",
        duration: "2 Hours",
        tip: "Buy fresh spices directly from the plantations"
      },
      {
        name: "Elephant Junction",
        image: "/assets/img/elephant-junction.png",
        description: "A unique eco-tourism spot where you can interact with elephants, enjoy elephant rides, and watch elephants being bathed and fed.",
        highlight: "Elephant Interaction",
        bestTime: "Morning",
        duration: "1-2 Hours",
        tip: "Visit during feeding time for the best experience"
      },
      {
        name: "Mangala Devi Temple",
        image: "/assets/img/mangala-devi.jpg",
        description: "An ancient temple located in the dense forest, offering panoramic views of the Western Ghats. Open only during specific festivals.",
        highlight: "Ancient Temple",
        bestTime: "April-May",
        duration: "2-3 Hours",
        tip: "Check festival dates before planning"
      },
      {
        name: "Kadathanadan Kalari Centre",
        image: "/assets/img/kalari.jpg",
        description: "Experience the ancient martial art of Kalaripayattu with live performances showcasing traditional weapons and fighting techniques.",
        highlight: "Martial Arts",
        bestTime: "Evening",
        duration: "1 Hour",
        tip: "Arrive early for the best seats"
      },
      {
        name: "Chellarkovil Viewpoint",
        image: "/assets/img/chellarkovil.jpeg",
        description: "A scenic viewpoint offering stunning views of the Western Ghats, tea plantations, and a beautiful waterfall cascading into Tamil Nadu.",
        highlight: "Breathtaking Views",
        bestTime: "Morning",
        duration: "1 Hour",
        tip: "Great for photography"
      },
      {
        name: "Periyar Tiger Trail",
        image: "/assets/img/tiger-trail.jpg",
        description: "An adventurous trekking program organized by the Forest Department offering opportunities to spot tigers, elephants, and other wildlife.",
        highlight: "Trekking Adventure",
        bestTime: "Oct-Feb",
        duration: "4-6 Hours",
        tip: "Advance booking required"
      }
    ];

    const experiences = [
      {
        title: "Wildlife Safari",
        description: "Boat and jeep safaris to spot elephants, tigers, and exotic birds",
        icon: "fas fa-paw"
      },
      {
        title: "Spice Tours",
        description: "Guided tours through aromatic spice plantations",
        icon: "fas fa-seedling"
      },
      {
        title: "Trekking",
        description: "Adventure trails through dense forests and hills",
        icon: "fas fa-hiking"
      },
      {
        title: "Cultural Shows",
        description: "Traditional Kalaripayattu martial arts performances",
        icon: "fas fa-mask"
      }
    ];

    const quickInfo = [
      { label: "Location", value: "Idukki District, Kerala", icon: "fas fa-map-marker-alt" },
      { label: "Best Time to Visit", value: "October to February", icon: "fas fa-calendar-alt" },
      { label: "Nearest Airport", value: "Madurai Airport (140 km) / Cochin (190 km)", icon: "fas fa-plane" },
      { label: "Nearest Railway", value: "Kottayam (114 km) / Theni (80 km)", icon: "fas fa-train" },
      { label: "Famous For", value: "Wildlife, Spices, Trekking", icon: "fas fa-tree" },
      { label: "Language", value: "Malayalam, English, Tamil", icon: "fas fa-language" }
    ];

    const wildlifeSpottings = [
      { name: "Indian Elephant", season: "All Year", probability: "High" },
      { name: "Bengal Tiger", season: "Oct-May", probability: "Medium" },
      { name: "Sambar Deer", season: "All Year", probability: "High" },
      { name: "Nilgiri Langur", season: "All Year", probability: "High" },
      { name: "Wild Boar", season: "All Year", probability: "Medium" },
      { name: "Malabar Giant Squirrel", season: "All Year", probability: "Medium" }
    ];

    const spices = [
      { name: "Cardamom", description: "Queen of spices, widely cultivated in Thekkady" },
      { name: "Pepper", description: "King of spices, black gold of Kerala" },
      { name: "Cinnamon", description: "Aromatic bark used in cooking and medicine" },
      { name: "Nutmeg", description: "Fragrant spice with numerous health benefits" },
      { name: "Clove", description: "Aromatic flower buds with medicinal properties" },
      { name: "Vanilla", description: "Premium orchid-based flavoring spice" }
    ];

    return (
      <div className="dest-destination-page">
        {/* Hero Section */}
        <div className="destination-hero">
          <div className="dest-hero-overlay"></div>
          <div className="dest-hero-background">
            <img src="/assets/img/thekkady-hero.png" alt="Thekkady Wildlife" />
          </div>
          <div className="dest-hero-content">
            <div className="dest-hero-badge">
              <span>Wilderness Adventure</span>
            </div>
            <h1 className="dest-hero-title">Thekkady</h1>
            <p className="dest-hero-subtitle">
              Where nature's wild heart beats with the rhythm of the forest
            </p>
            <div className="dest-hero-location">
              <i className="fas fa-map-marker-alt"></i>
              <span>Idukki District, Kerala, India</span>
            </div>
          </div>
          <div className="dest-hero-scroll">
            <span>Scroll to explore</span>
            <i className="fas fa-chevron-down"></i>
          </div>
        </div>

        {/* Introduction Section */}
        <div className="dest-intro-section">
          <Grid>
            <Row>
              <Col xs={12} md={7} className="dest-intro-text">
                <h2 className="dest-section-title">Welcome to Thekkady</h2>
                <p className="dest-intro-description">
                  Thekkady is one of Kerala's most spectacular wildlife destinations, home to the 
                  Periyar Wildlife Sanctuary. This lush green paradise is nestled in the Cardamom 
                  Hills of the Western Ghats, offering a perfect blend of wildlife, adventure, and 
                  natural beauty.
                </p>
                <p className="dest-intro-description">
                  The Periyar Tiger Reserve is the main attraction, known for its thriving elephant 
                  population and the chance to spot the elusive Bengal tiger. The artificial Periyar 
                  Lake adds to the scenic beauty, offering boat safaris that provide excellent 
                  wildlife viewing opportunities.
                </p>
                <div className="dest-highlight-box">
                  <i className="fas fa-star"></i>
                  <span>Did You Know? Periyar Tiger Reserve is one of the 27 tiger reserves in India and was declared a Project Tiger reserve in 1978.</span>
                </div>
              </Col>
              <Col xs={12} md={5} className="dest-quick-info">
                <h3>Quick Facts</h3>
                <div className="dest-info-grid">
                  {quickInfo.map((info, index) => (
                    <div key={index} className="dest-info-card">
                      <div className="dest-info-icon">
                        <i className={info.icon}></i>
                      </div>
                      <div className="dest-info-content">
                        <span className="dest-info-label">{info.label}</span>
                        <span className="dest-info-value">{info.value}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Experiences Section */}
        <div className="dest-experiences-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title-centered">Experiences in Thekkady</h2>
            <p className="dest-section-subtitle">
              Adventure awaits in the wilderness
            </p>
          </div>
          <Grid>
            <Row className="experiences-grid">
              {experiences.map((exp, index) => (
                <Col xs={12} sm={6} md={3} key={index} className="experience-col">
                  <div className="experience-card">
                    <div className="exp-icon">
                      <i className={exp.icon}></i>
                    </div>
                    <h4 className="exp-title">{exp.title}</h4>
                    <p className="exp-description">{exp.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Attractions Section */}
        <div className="dest-attractions-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title-centered">Top Attractions in Thekkady</h2>
            <p className="dest-section-subtitle">
              Discover the wild heart of Kerala
            </p>
          </div>

          <Grid>
            <Row className="dest-attractions-grid">
              {attractions.map((attraction, index) => (
                <Col xs={12} sm={6} md={4} lg={3} key={index} className="dest-attraction-col">
                  <div className="dest-attraction-card">
                    <div className="dest-card-image">
                      <img src={attraction.image} alt={attraction.name} />
                      <div className="dest-card-overlay">
                        <span className="dest-highlight-tag">{attraction.highlight}</span>
                      </div>
                    </div>
                    <div className="dest-card-content">
                      <h3 className="dest-attraction-name">{attraction.name}</h3>
                      <p className="dest-attraction-description">{attraction.description}</p>
                      <div className="dest-card-footer">
                        <div className="dest-time-info">
                          <span className="dest-best-time">
                            <i className="far fa-calendar"></i>
                            {attraction.bestTime}
                          </span>
                          <span className="dest-duration">
                            <i className="far fa-clock"></i>
                            {attraction.duration}
                          </span>
                        </div>
                        <div className="dest-travel-tip">
                          <i className="fas fa-lightbulb"></i>
                          <span>{attraction.tip}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Wildlife Section */}
        <div className="wildlife-section">
          <div className="wildlife-overlay"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="wildlife-content">
                <div className="wildlife-badge">Wildlife Sanctuary</div>
                <h2 className="wildlife-title">Periyar Tiger Reserve</h2>
                <p className="wildlife-description">
                  Spanning over 925 sq km, the Periyar Tiger Reserve is one of India's most 
                  well-managed tiger reserves. The reserve is centered around the picturesque 
                  Periyar Lake, formed by the Mullaperiyar Dam.
                </p>
                <p className="wildlife-description">
                  The reserve is home to a diverse range of wildlife including tigers, elephants, 
                  leopards, wild dogs, sambar deer, and over 300 species of birds. The boat safari 
                  on Periyar Lake offers excellent opportunities to spot wildlife along the water's edge.
                </p>
                <div className="wildlife-stats">
                  <div className="stat">
                    <span className="number">925</span>
                    <span className="label">Sq km Area</span>
                  </div>
                  <div className="stat">
                    <span className="number">300+</span>
                    <span className="label">Bird Species</span>
                  </div>
                  <div className="stat">
                    <span className="number">50+</span>
                    <span className="label">Mammal Species</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Wildlife Spottings Section */}
        <div className="wildlife-spottings-section">
          <Grid>
            <div className="section-header">
              <h2 className="section-title-centered">Wildlife You Can Spot</h2>
              <p className="section-subtitle">
                Keep your camera ready for these magnificent creatures
              </p>
            </div>
            <Row className="spottings-grid">
              {wildlifeSpottings.map((animal, index) => (
                <Col xs={12} sm={6} md={4} key={index} className="spottings-col">
                  <div className="spottings-card">
                    <div className="animal-icon">
                      <i className="fas fa-paw"></i>
                    </div>
                    <h4 className="animal-name">{animal.name}</h4>
                    <div className="animal-details">
                      <span><strong>Season:</strong> {animal.season}</span>
                      <span className={`probability ${animal.probability.toLowerCase()}`}>
                        <strong>Probability:</strong> {animal.probability}
                      </span>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Spice Plantation Section */}
        <div className="spice-section">
          <div className="spice-overlay"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="spice-content">
                <div className="spice-badge">Aromatic Paradise</div>
                <h2 className="spice-title">Spice Plantations of Thekkady</h2>
                <p className="spice-description">
                  Thekkady is renowned for its vast spice plantations that produce some of the 
                  finest spices in India. The rolling hills are covered with cardamom, pepper, 
                  cinnamon, nutmeg, cloves, and vanilla plantations.
                </p>
                <p className="spice-description">
                  A guided tour through these plantations offers fascinating insights into spice 
                  cultivation, processing, and their medicinal uses. Visitors can purchase fresh, 
                  high-quality spices directly from the plantations.
                </p>
                <div className="spice-list">
                  {spices.slice(0, 6).map((spice, index) => (
                    <div key={index} className="spice-item">
                      <i className="fas fa-leaf"></i>
                      <div>
                        <strong>{spice.name}</strong>
                        <p>{spice.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Kalaripayattu Section */}
        <div className="kalari-section">
          <Grid>
            <Row>
              <Col xs={12} md={6} className="kalari-content">
                <div className="kalari-badge">Ancient Martial Art</div>
                <h2 className="kalari-title">Kalaripayattu - The Art of Warfare</h2>
                <p className="kalari-description">
                  Kalaripayattu is one of the oldest martial arts in the world, originating in Kerala. 
                  Thekkady offers authentic performances of this ancient art form, showcasing 
                  breathtaking combat techniques, weaponry, and physical agility.
                </p>
                <p className="kalari-description">
                  The evening performances at Kadathanadan Kalari Centre are particularly popular, 
                  featuring demonstrations of swords, shields, spears, and other traditional weapons. 
                  The performances conclude with the awe-inspiring "Marma" treatment demonstrations.
                </p>
                <div className="kalari-features">
                  <div className="feature">
                    <i className="fas fa-fist-raised"></i>
                    <span>Traditional Combat Techniques</span>
                  </div>
                  <div className="feature">
                    <i className="fas fa-shield-alt"></i>
                    <span>Weapon Demonstrations</span>
                  </div>
                  <div className="feature">
                    <i className="fas fa-user-graduate"></i>
                    <span>Live Performances</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Travel Tips Section */}
        <div className="dest-tips-section">
          <Grid>
            <div className="dest-section-header">
              <h2 className="dest-section-title-centered">Travel Tips for Thekkady</h2>
              <p className="dest-section-subtitle">Make the most of your wildlife adventure</p>
            </div>
            <Row className="dest-tips-grid">
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-camera"></i>
                  </div>
                  <h4>Wildlife Photography</h4>
                  <p>Carry a zoom lens for wildlife photography. Early morning and late afternoon are best for sightings.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-ticket-alt"></i>
                  </div>
                  <h4>Book Safaris in Advance</h4>
                  <p>Boat and jeep safaris get booked quickly. Reserve tickets 1-2 days in advance.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-tshirt"></i>
                  </div>
                  <h4>What to Wear</h4>
                  <p>Wear earthy colors (brown, green, khaki) for better wildlife spotting. Avoid bright colors.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-bug"></i>
                  </div>
                  <h4>Essential Items</h4>
                  <p>Carry mosquito repellent, sunscreen, binoculars, and comfortable walking shoes.</p>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* CTA Section */}
        <div className="dest-cta-section">
          <div className="dest-cta-content">
            <h3>Ready for a Wild Adventure?</h3>
            <p>Let us help you explore the wilderness of Thekkady</p>
            <Link to="/contact" className="dest-cta-button">
              Plan Your Safari
              <i className="fas fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}